import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import {
  editKidProfile,
  editKidImage,
  setAddKidStatus,
  deleteKidAccount,
} from "../../AxiosRtk/AddNewChild";
import {
  getPreSignedUrl,
  uploadFileToS3,
  getMyIPAddress,
} from "../../AxiosRtk/Miscellaneous";
import {
  kidDevices,
  setKidDevicesList,
  setKidList,
  setSelectedKidId,
} from "../../AxiosRtk/DashBoard";
import useCrypto from "../../../customHooks/crypto";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import useKidListFunctionality from "../../../customHooks/kidListHook";
import LoadingIndicator from "../../../../setup/Loader/LoaderIndicator";
import useLangTranslation from "../../../customHooks/languageProvider";
import { useHistory } from "react-router-dom";
import { setShowMessage } from "../../AxiosRtk/successMessage";
import useFirebase from "../../../../useFirebase";
import { constant } from "../../../../utils/constant";
import Select from "react-select";
import BatteryPercentage from "./BatteryPercentage";

export function DeviceStatus({ status }) {
  const { getLangTranslation } = useLangTranslation();

  if (status === 1)
    return (
      <>
        <span className="text-small me-3 text-success">
          {getLangTranslation("CHILD_DEVICE_ACTIVE_NOW", "Active Now")}
        </span>
      </>
    );
  if (status === 0) {
    return (
      <>
        <span className="text-small me-3 text-secondary">
          {getLangTranslation("CHILD_DEVICE_INACTIVE_NOW", "Inactive Now")}
        </span>
      </>
    );
  }

  return (
    <>
      <span className={`text-small me-3 text-gray`}>Status unknown</span>
    </>
  );
}

const EditChildProfile = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { encodeNumberToBase64 } = useCrypto();
  const [myIp, setMyIp] = useState("");
  const [deviceStatusData, setDeviceStatus] = useState([]);
  const { getLangTranslation } = useLangTranslation();
  const { kidDevicesList, kidList, selectedKidId } = useSelector(
    ({ dashboard }) => dashboard
  );

  const [formData, setFormData] = useState({
    ID: null,
    childName: "",
    gender: null,
    dob: "",
    image: "",
    file: null,
    thumbnail: ""
  });
  const [originalData, setOriginalData] = useState({});
  const [isChanged, setIsChanged] = useState(false);
  const [presignedData, setPresignedData] = useState("");
  const kidGenderOption = [
    { label: "Male", value: "1" },
    { label: "Female", value: "2" },
  ];

  const [loader, setLoader] = useState(false);
  const [kidDelLoader, setKidDelLoader] = useState(false);
  const { getDeviceStatus } = useFirebase();
  const selectedKidDetails = kidList?.find(
    (item) => item?.ID === selectedKidId
  );

  const { ID, childName, gender, dob, file } = formData;
  const { getImage } = useKidListFunctionality();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const { ID, childName, gender, dob, image, thumbnail } = selectedKidDetails;
    const genderSelect = kidGenderOption?.find(
      (item) => item?.label?.toLowerCase() === gender?.toLowerCase()
    );

    const initialFormData = {
      ID,
      childName,
      gender: genderSelect,
      dob: moment(dob, 'DD-MM-YYYY').format("YYYY-MM-DD"),
      image: "",
      thumbnail: thumbnail?.split("/")[1]
    };

    setFormData(initialFormData);
    setOriginalData(initialFormData);

    if (selectedKidId) {
      kidDevices(selectedKidId)
        .then((res) => {
          dispatch(setKidDevicesList(res?.data?.result));
        })
        .catch((err) => {
          console.log(
            "kid device list catch error ==>>",
            err?.response?.data?.message
          );
        });
    } else {
      dispatch(setKidDevicesList([]));
    }

    getMyIPAddress()
      .then(({ data }) => {
        setMyIp(data?.ip);
      })
      .catch((err) => {
        console.log("getting current ip address catch error ==>>", err);
      });
  }, []);

  useEffect(() => {
    if (kidDevicesList?.length > 0) {
      const promiseArr = [];
      kidDevicesList?.forEach((item) => {
        promiseArr.push(getDeviceStatus(item?.ID));
      });

      Promise.allSettled([...promiseArr])
        .then((res) => {
          setDeviceStatus(res);
        })
        .catch((err) => {
          console.log("err ==>>", err);
        });
    } else {
      setDeviceStatus([]);
    }
  }, [kidDevicesList]);

  useEffect(() => {
    setIsChanged(
      formData.childName !== originalData.childName ||
        formData.gender?.value !== originalData.gender?.value ||
        formData.dob !== originalData.dob || formData.image 
    );
  }, [formData, originalData]);

  function handleInputChange(e) {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  }

  const handleImageUpload = async (event) => {
    const payload = {
      type: "put",
      fileName: `${encodeNumberToBase64(
        selectedKidDetails?.parentID
      )}/ProfilesPics/${event.target.files[0].name}`,
    };

    try {
      getPreSignedUrl(payload)
        .then((res) => {
          setPresignedData(res?.data?.result);
        })
        .catch((err) => {
          console.log(
            "catch error presigned url ==>>",
            err?.response?.data?.message
          );
        });
    } catch (error) {
      console.log(error);
    }

    setFormData({
      ...formData,
      file: event.target.files[0],
      image: URL.createObjectURL(event.target.files[0]),
    });
  };

  const fiveYearsBack = () => {
    const todayDateString = new Date();
    var d = new Date(moment(todayDateString).locale("en").format("YYYY-MM-DD"));
    d.setFullYear(d.getFullYear() - 5);
    return d;
  };

  function handleImageUploadToS3() {
    uploadFileToS3(`${presignedData?.signedUrlForPutObject}`, file, {
      "Content-Type": file?.type,
      version_code: 20000,
    })
      .then(() => {
        const kidImgPayload = {
          kidId: ID,
          childPic: `${
            process.env.REACT_APP_IMAGE_BUCKET_PHASE2_DEV
          }/${encodeNumberToBase64(
            selectedKidDetails?.parentID
          )}/ProfilesPics/${file?.name}`,
        };
        editKidImage(kidImgPayload)
          .then(() => {})
          .catch((error) => {
            console.log(
              "kid image upload catch error ==>>",
              error?.response?.data?.message
            );
          });
      })
      .catch((error) => {
        console.log("upload to s3 catch error ==>>", error?.response);
      });
  }

  function handleEdit() {
    const payload = {
      kidId: ID,
      childName: childName,
      dob: moment(dob).locale("en").format("DD-MM-YYYY"),
      gender: gender?.value,
    };
    setLoader(true);
    editKidProfile(payload)
      .then((res) => {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: "Child profile updated successfully",
            message: "KID_PROFILE_UPDATE_SUCCESS_TXT",
          })
        );
        if (file) {
          handleImageUploadToS3();
        }

        const kidListTemp = kidList?.map((item) => {
          const isConditionTrue =
            item?.ID === selectedKidId &&
            selectedKidDetails?.gender &&
            item?.gender?.toLowerCase() !==
              formData?.gender?.label?.toLowerCase();
          if (isConditionTrue) {
            return {
              ...item,
              gender: formData?.gender?.label || item?.gender,
            };
          }

          return item;
        });

        dispatch(setKidList(kidListTemp));
      })
      .catch((err) => {
        console.log("edit kid profile catch error ===>>>", err?.response);
      })
      .finally(() => {
        setLoader(false);
      });
  }

  function handleDeleteKidAccount() {
    if (ID) {
      setKidDelLoader(true);
      deleteKidAccount({
        kidId: ID,
        kidName: childName,
        ipAddress: myIp,
        reason: "Any",
      })
        .then((res) => {
          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: "The child's profile was deleted successfully",
              message: "KID_DELETED",
            })
          );
          if (kidList?.length > 0) {
            dispatch(setSelectedKidId(kidList[0]?.ID));
          } else {
            dispatch(setSelectedKidId(null));
          }
          setTimeout(() => {
            history.push("/dashboard");
          }, 3000);
        })
        .catch((err) => {
          console.log(
            "delete kid account catch error ==>>",
            err?.response?.data?.message
          );
        })
        .finally(() => {
          setKidDelLoader(false);
        });
    }
  }

  return (
    <div className="card">
      <div className="card-body px-6 px-md-9 py-6 py-md-9">
        <div className="content-550 mx-auto">
          <div className="d-flex align-items-center lh-1 mb-6">
            <Link to="/dashboard" className="text-blue-900 fs-5 d-flex">
              <i className="icon-arrow-left" />
              <h4 className="mb-0 text-blue-900">
                {`${getLangTranslation(
                  "EDIT_CHILD_TITLE_EDIT",
                  "Edit"
                )} ${childName} ${getLangTranslation(
                  "EDIT_CHILD_TITLE_PROFILE",
                  "profile"
                )}`}
              </h4>
            </Link>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div className="image-placeholder add-image ratio ratio-1x1 mb-6">
              <img
                src={formData?.image ? formData?.image : getImage(formData?.thumbnail, formData?.gender?.label)}
                alt="Child Pic"
                className="rounded-circle"
                onError={(event) => {
                  event.target.onerror = null;
                  event.target.src = getImage("", formData?.gender?.label);
                }}
              />
            </div>
            <button className="btn btn-outline-primary custom-file-wrap d-inline-flex align-items-center gap-1 mb-6">
              <i className="icon-plus fs-6" />
              {getLangTranslation(
                "EDIT_PROFILE_BUTTON_ADD_AVTAR",
                "Add child's avatar"
              )}
              <input
                name="childPic"
                type="file"
                accept=".png, .jpg, .jpeg, .svg, .avif"
                onChange={handleImageUpload}
              />
            </button>
          </div>
          <div className="mb-6">
            <label htmlFor="childName" className="form-label">
              {getLangTranslation("EDIT_CHILD_FULL_NAME", "Full Name")}
            </label>
            <input
              type="text"
              className="form-control"
              id="childName"
              placeholder=""
              name="childName"
              value={childName}
              onChange={handleInputChange}
            />
          </div>

          <div className="mb-6">
            <label htmlFor="gender" className="form-label">
              {getLangTranslation("ADD_CHILD_GENDER", "Gender")}
            </label>
            <Select
              className="custom-select"
              classNamePrefix="custom-select"
              placeholder="Select Gender"
              onChange={(val) =>
                setFormData({
                  ...formData,
                  gender: val,
                })
              }
              options={kidGenderOption}
              value={formData?.gender}
            />
          </div>

          <div className="mb-6">
            <label className="form-label">
              {getLangTranslation("EDIT_CHILD_DATE_OF_BIRTH", "Date of birth")}
            </label>
            <input
              type="date"
              id="basic-datepicker"
              className="form-control"
              name="dob"
              value={dob}
              max={moment(fiveYearsBack())
                .locale("en")
                .format("YYYY-MM-DD")
                .toString()}
              onChange={handleInputChange}
            />
          </div>
          <button
            className="btn btn-outline-primary w-100 mb-6"
            type="button"
            onClick={handleEdit}
            disabled={!isChanged} // Disable the button if no changes
          >
            {loader ? (
              <LoadingIndicator
                height={20}
                width={100}
                color={constant?.color?.DODGER_BLUE}
              />
            ) : (
              <span className="btn-upper-case">
                {getLangTranslation("ADD_CHILD_SAVE", "Save")}
              </span>
            )}
          </button>
          {kidDevicesList?.length > 0 && (
            <label className="form-label">
              {getLangTranslation(
                "EDIT_CHILD_LINKED_DEVICES",
                "Linked devices"
              )}
            </label>
          )}

          {kidDevicesList?.map((item, index) => {
            return (
              <div
                className="d-flex align-items-center border p-1 rounded-3 bg-gray-300 mb-3"
                key={item?.ID}
              >
                <span className="icon-wrap icon-blue me-2">
                  <i className="icon-mobile"></i>
                </span>
                <h5 className="mb-0 text-dark me-auto">{item?.Name}</h5>
                <DeviceStatus
                  status={deviceStatusData[index]?.value?.data?.deviceStatus}
                />
                <BatteryPercentage deviceId={item?.ID} />
                <i className="icon-battery-charging fs-5" />
              </div>
            );
          })}

          <div className="grid gap-3">
            <button
              className="btn btn-primary g-col-12 g-col-md-6"
              type="button"
              onClick={() => {
                history.push("/connect-child-device");
                dispatch(setAddKidStatus("EDIT_KID_CONNECT_CHILD_DEVICE"));
              }}
            >
              <span className="btn-upper-case">
                {getLangTranslation(
                  "EDIT_CHILD_ADD_NEW_DEVICE",
                  "Add new device"
                )}
              </span>
            </button>
            <button
              className="btn btn-outline-primary g-col-12 g-col-md-6"
              type="button"
              onClick={handleDeleteKidAccount}
            >
              {kidDelLoader ? (
                <LoadingIndicator height={20} width={100} />
              ) : (
                <span className="btn-upper-case">
                  {getLangTranslation(
                    "EDIT_CHILD_DELETE_CHILD_PROFILE",
                    "DELETE child PROFILE"
                  )}
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditChildProfile;
